export enum KeyboardKeyType {
  ARROWUP = "ArrowUp",
  ARROWDOWN = "ArrowDown",
  ARROWLEFT = "ArrowLeft",
  ARROWRIGHT = "ArrowRight",
  ENTER = "Enter",
  TAB = "Tab",
  SPACE = "Space",
}
